<template>
  <div class="app-product-aid-explanation">
    <div class="app-product-aid-explanation__content">
      <h2 class="app-product-aid-explanation__title">
        {{ title }}
      </h2>

      <div class="app-product-aid-explanation__instructions">
        <div class="app-product-aid-explanation__instruction">
          <NuxtImg
            :src="likeIcon"
            :alt="t('marketingPages.productAid.intro.likeIconAlt')"
            provider="storyblok"
            :height="getImageDimensionsFromStoryblokSrc(likeIcon).height"
            :width="getImageDimensionsFromStoryblokSrc(likeIcon).width"
          />
          <div v-html="introInstructionLike" />
        </div>

        <div class="app-product-aid-explanation__instruction">
          <NuxtImg
            :src="dislikeIcon"
            :alt="t('marketingPages.productAid.intro.dislikeIconAlt')"
            provider="storyblok"
            :height="getImageDimensionsFromStoryblokSrc(dislikeIcon).height"
            :width="getImageDimensionsFromStoryblokSrc(dislikeIcon).width"
          />
          <div v-html="introInstructionDislike" />
        </div>
      </div>
    </div>

    <div class="flex justify-center">
      <TappButton class="app-product-aid-explanation__button" @click="emit('start')">
        {{ t('marketingPages.productAid.intro.startButton') }}
      </TappButton>
    </div>
  </div>
</template>

<script setup lang="ts">
  const { t } = useI18n();

  defineProps<{
    title: string;
    likeIcon: string;
    introInstructionLike: string;
    dislikeIcon: string;
    introInstructionDislike: string;
  }>();

  const emit = defineEmits<{
    start: [];
  }>();
</script>

<style lang="postcss" scoped>
  .app-product-aid-explanation {
    display: grid;
    grid-template-rows: 1fr auto;
    flex: 1;
    gap: var(--spacing-6);

    padding: var(--spacing-2);
    border-radius: var(--spacing-1);

    &__content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    &__title {
      margin-bottom: var(--spacing-8);
      color: var(--colors-black);
      text-align: center;
      text-wrap: balance;
    }

    &__instruction {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      padding: var(--spacing-6);
      border: 1px solid #494e4e;

      color: var(--colors-black);
      text-align: center;

      background: var(--colors-white);
    }

    &__instructions {
      display: grid;
      flex-direction: column;
      gap: var(--spacing-8);
    }
  }
</style>
